import React from "react";
import { motion } from "framer-motion";
import { Compass, Map, Sparkles, Landmark, Hammer, Home } from "lucide-react";
import { Reveal, Overline } from "./primitives";
import { JOURNEY } from "./content";

const EASE = [0.16, 1, 0.3, 1];
const ICONS = [Compass, Map, Sparkles, Landmark, Hammer, Home];

export default function Journey() {
  return (
    <section data-testid="journey-section" className="relative bg-warm py-28 md:py-40">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <Reveal className="mb-16 md:mb-24 max-w-[22ch]">
          <Overline className="text-copper">The Client Journey</Overline>
          <h2 className="mt-6 font-serif text-4xl leading-[1.05] text-ink sm:text-6xl lg:text-7xl">
            From first conversation to living destination.
          </h2>
        </Reveal>

        {/* Desktop: horizontal. Mobile: vertical */}
        <div className="relative">
          <div className="grid grid-cols-1 gap-y-12 md:grid-cols-6 md:gap-y-0">
            {JOURNEY.map((step, i) => {
              const Icon = ICONS[i];
              return (
                <motion.div
                  key={step.no}
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ duration: 0.8, ease: EASE, delay: i * 0.08 }}
                  className="relative flex gap-6 border-ink/10 pt-0 md:block md:border-t md:pr-6 md:pt-8"
                >
                  <div className="flex flex-col items-center md:hidden">
                    <span className="flex h-12 w-12 items-center justify-center rounded-full border border-ink/15 text-forest">
                      <Icon strokeWidth={1.25} size={20} />
                    </span>
                    {i < JOURNEY.length - 1 && <span className="mt-2 w-px flex-1 bg-ink/10" />}
                  </div>

                  <div>
                    <span className="hidden text-forest md:mb-6 md:flex">
                      <Icon strokeWidth={1.1} size={26} />
                    </span>
                    <span className="font-serif text-sm text-champagne">{step.no}</span>
                    <h3 className="mt-1 font-serif text-2xl text-ink md:text-[1.6rem]">{step.title}</h3>
                    <p className="mt-2 max-w-[24ch] text-sm leading-relaxed text-ink/55">
                      {step.body}
                    </p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
